<template>
    <div class="main">
        <div style="height: 40px; width: 100%; background-color: #f1f2f2; position: relative">
            <span
                style="
                    font-size: 24px;
                    font-weight: 600;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%) translateX(-50%);
                    left: 50%;
                "
                >中国</span
            >
        </div>

        <div style="height: 100%; width: 100%">
            <a-table
                class="table"
                :columns="columns"
                :data-source="data_china"
                :bordered="true"
                :scroll="{ x: '100%' }"
                size="small"
                :pagination="false"
                :row-key="(record, index) => index"
            >
                <template v-for="item in columns" :key="item.key" #[item.key]="{ record, text }">
                    <span :class="hasVideo(text) ? 'num' : 'num_disable'" @click="showRow(record, item)">{{ text.value }}</span>
                </template>
            </a-table>
        </div>
        <div style="margin-top: 20px; height: 40px; width: 100%; background-color: #f1f2f2; position: relative">
            <span
                style="
                    font-size: 24px;
                    font-weight: 600;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%) translateX(-50%);
                    left: 50%;
                "
                >日本</span
            >
        </div>
        <div style="height: 100%; width: 100%">
            <a-table
                class="table"
                :columns="columns"
                :data-source="data_japan"
                :bordered="true"
                :scroll="{ x: '100%' }"
                size="small"
                :pagination="false"
                :row-key="(record, index) => index"
            >
                <template v-for="item in columns" :key="item.key" #[item.key]="{ record, text }">
                    <span :class="hasVideo(text) ? 'num' : 'num_disable'" @click="showRow(record, item)">{{ text.value }}</span>
                </template>
            </a-table>
        </div>

        <video-dialog
            :videoTitle="videoTitle"
            :visible="showVideo"
            :header="`https://k8-data-analysis.oss-cn-beijing.aliyuncs.com/2021世预赛视频/${date}/`"
            :videos="videos"
            @close="close"
        />
    </div>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue'
import videoDialog from '@/components/videoDialog'
import { useRoute } from 'vue-router'

export default defineComponent({
    name: 'PanelData',
    components: {
        videoDialog,
    },
    props: {},
    setup() {
        const data_china = ref([])
        const data_japan = ref([])
        const showVideo = ref(false)
        const date = ref('')
        const columns = [
            {
                title: '号码',
                key: 'num',
                width: 35,
                dataIndex: 'num',
                align: 'center',
                fixed: 'left',
                customCell: () => {
                    return { style: { 'font-weight': '600' } }
                },
                customRender: ({ text }) => {
                    return {
                        children: text,
                        props: {
                            colSpan: text === '总计' ? 2 : 1,
                        },
                    }
                },
            },
            {
                title: '球员',
                key: 'name',
                dataIndex: 'name',
                width: 70,
                align: 'center',
                fixed: 'left',
                customCell: () => {
                    return { style: { 'font-weight': '600' } }
                },
                customRender: ({ text }) => {
                    return {
                        children: text,
                        props: {
                            colSpan: text === '总计' ? 0 : 1,
                        },
                    }
                },
            },
            {
                title: '得分',
                key: 'score',
                dataIndex: 'score',
                width: 50,
                align: 'center',
                slots: { customRender: 'score' },
            },
            {
                title: '两分出手',
                key: 'TWOPA',
                dataIndex: 'TWOPA',
                width: 50,
                align: 'center',
                slots: { customRender: 'TWOPA' },
            },
            {
                title: '两分命中',
                key: 'TWOPM',
                dataIndex: 'TWOPM',
                width: 50,
                align: 'center',
                slots: { customRender: 'TWOPM' },
            },
            {
                title: '两分不中',
                key: 'TWOPm',
                dataIndex: 'TWOPm',
                width: 50,
                align: 'center',
                slots: { customRender: 'TWOPm' },
            },
            {
                title: '两分%',
                key: 'TWOperc',
                dataIndex: 'TWOperc',
                width: 65,
                align: 'center',
            },
            {
                title: '三分出手',
                key: 'THREEPA',
                dataIndex: 'THREEPA',
                width: 50,
                align: 'center',
                slots: { customRender: 'THREEPA' },
            },
            {
                title: '三分命中',
                key: 'THREEPM',
                dataIndex: 'THREEPM',
                width: 50,
                align: 'center',
                slots: { customRender: 'THREEPM' },
            },
            {
                title: '三分不中',
                key: 'THREEPm',
                dataIndex: 'THREEPm',
                width: 50,
                align: 'center',
                slots: { customRender: 'THREEPm' },
            },
            {
                title: '三分%',
                key: 'THREEperc',
                dataIndex: 'THREEperc',
                width: 60,
                align: 'center',
            },

            {
                title: '罚球出手',
                key: 'FTA',
                dataIndex: 'FTA',
                width: 50,
                align: 'center',
                slots: { customRender: 'FTA' },
            },
            {
                title: '罚球命中',
                key: 'FTM',
                dataIndex: 'FTM',
                width: 50,
                align: 'center',
                slots: { customRender: 'FTM' },
            },
            {
                title: '罚球不中',
                key: 'FTm',
                dataIndex: 'FTm',
                width: 50,
                align: 'center',
                slots: { customRender: 'FTm' },
            },
            {
                title: '罚球%',
                key: 'FTperc',
                dataIndex: 'FTperc',
                width: 60,
                align: 'center',
            },
            {
                title: '前板',
                key: 'OREB',
                dataIndex: 'OREB',
                width: 50,
                align: 'center',
                slots: { customRender: 'OREB' },
            },
            {
                title: '后板',
                key: 'DREB',
                dataIndex: 'DREB',
                width: 50,
                align: 'center',
                slots: { customRender: 'DREB' },
            },
            {
                title: '总板',
                key: 'TREB',
                dataIndex: 'TREB',
                width: 50,
                align: 'center',
                slots: { customRender: 'TREB' },
            },
            {
                title: '助攻',
                key: 'AST',
                dataIndex: 'AST',
                width: 50,
                align: 'center',
                slots: { customRender: 'AST' },
            },

            {
                title: '抢断',
                key: 'STL',
                dataIndex: 'STL',
                width: 50,
                align: 'center',
                slots: { customRender: 'STL' },
            },

            {
                title: '失误',
                key: 'TO',
                dataIndex: 'TO',
                width: 50,
                align: 'center',
                slots: { customRender: 'TO' },
            },

            {
                title: '盖帽',
                key: 'BLK',
                dataIndex: 'BLK',
                width: 50,
                align: 'center',
                slots: { customRender: 'BLK' },
            },

            {
                title: '犯规',
                key: 'FOUL',
                dataIndex: 'FOUL',
                width: 50,
                align: 'center',
                slots: { customRender: 'FOUL' },
            },
        ]
        const videoTitle = ref()
        const videos = ref([])
        onMounted(() => {
            const route = useRoute()
            date.value = route.query.type
            data_china.value = require('../../assets/word_cup_data/' + date.value + '/china_panel_data.json')
            data_japan.value = require('../../assets/word_cup_data/' + date.value + '/japan_panel_data.json')
        })

        const close = () => {
            showVideo.value = false
        }
        const hasVideo = (item) => {
            return item.value > 0
        }
        const showRow = (record, item) => {
            videoTitle.value = record.name + '-' + item.title
            record[item.key].time.forEach((item) => {
                videos.value.push(item + '.mp4')
            })
            showVideo.value = true
        }

        return {
            data_china,
            data_japan,
            showVideo,
            videoTitle,
            date,
            close,
            columns,
            hasVideo,
            showRow,
            videos,
        }
    },
})
</script>

<style lang="less" scoped>
.main {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    padding: 10px 10px;
    background: url('../../assets/bg_word_cup.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.table {
    border-radius: 2px;
    background-color: white;
}

.num {
    color: #129cfe;
    cursor: pointer;
}

.num_disable {
    color: #333;
}
</style>
